"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const yup_1 = require("yup");
exports.validationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: (0, yup_1.string)().required("form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map